var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEveningNotAvailable(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 22,
    viewBox: "0 0 30 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Evening-not-available"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 4200",
    x: 1.16406,
    y: 0.5,
    width: 27.3625,
    height: 20.78,
    rx: 5.5,
    fill: "white",
    stroke: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "E",
    d: "M14.3006 7.1079V9.7599H17.4206V10.9689H14.3006V13.7379H17.8106V14.9469H12.8186V5.8989H17.8106V7.1079H14.3006Z",
    fill: "#233849"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 66",
    x1: 26.2817,
    y1: 3.41311,
    x2: 4.28167,
    y2: 18.4131,
    stroke: "#B0AFAF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEveningNotAvailable);
export default __webpack_public_path__ + "static/media/Evening-not-available.965ffc2daf1d3d8063f04f8e811d9efd.svg";
export { ForwardRef as ReactComponent };